import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getPlayerReport } from "../../../services/ReportService";

const TotalPlayersModal = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchPreviewData();
    }
  }, [show]);

  const fetchPreviewData = async () => {
    setLoading(true);
    try {
      const res = await getPlayerReport(0, 10, "");
      const items = Array.isArray(res) ? res : res?.content || res?.data || [];
      setData(items);
    } catch (error) {
      console.error("Error fetching preview player data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowMore = () => {
    onHide();
    navigate("/admin/player-reports");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-18 fw-bold">
          <i className="fas fa-users text-primary me-2"></i>
          Total Players - Recent Players List
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted">Loading players...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover responsive className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Player Id</th>
                  <th>Player Name</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Package</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item?.serialNumber || item?.player?.serialNumber || "-"}</td>
                      <td className="fw-semibold">{item?.name || item?.player?.name || "-"}</td>
                      <td>{item?.phone || item?.player?.phone || item?.mobile || "-"}</td>
                      <td>{item?.email || item?.player?.email || "-"}</td>
                      <td>
                        {item?.subscription?.packageType?.name ||
                          item?.playerSubscription?.packageType?.name ||
                          item?.packageType?.name ||
                          item?.packageType ||
                          "-"}
                      </td>
                      <td>
                        <span
                          className={`badge badge-sm ${item?.status === "Active" ||
                              item?.status === "ACTIVE" ||
                              item?.player?.status === "Active" ||
                              item?.player?.status === "ACTIVE"
                              ? "badge-success"
                              : "badge-secondary"
                            }`}
                        >
                          {item?.status || item?.player?.status || "Active"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center py-4 text-muted">
                      No players found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleShowMore}>
          <i className="fas fa-external-link-alt me-2"></i> Show More (View Full Report)
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TotalPlayersModal;
